import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/sign-in")({
  head: () =>
    pageHead("Sign In", {
      canonicalPath: "/sign-in",
      robots: "noindex, nofollow",
    }),
});
